
const competitionUserRutes = [
  {
    path: ':usernameCompetition',
    component: () => import('../views/competition/CompetitionPage.vue'),
    children: [
      {
        path: '',
        name: 'competition-user',
        component: () => import('../views/competition/TorneosCompetitionPage.vue'),
      },
      {
        path: 'noticias',
        name: 'competition-user-noticias',
        component: () => import('../views/competition/NewsCompetitionPage.vue'),
      },
      {
        path: 'resultados',
        name: 'competition-user-resultados',
        component: () => import('../views/competition/ResultsCompetitionPage.vue'),
      },
      {
        path: 'calendario',
        name: 'competition-user-calendario',
        component: () => import('../views/competition/CalendarioCompetitionPage.vue'),
      },
      {
        path: 'campeones',
        name: 'competition-user-campeones',
        component: () => import('../views/competition/CampeonesCompetitionPage.vue'),
      },
    ]
  },
  // ==========================================================================
  // ======================COMPETITION USER ADMIN ====================
  // ==========================================================================
  {
    path: 'competition/:idCompe',
    component: () => import('../views/competition/ResumeCompeAdminPage.vue'),
    meta: {requiresAuth: true},
    children: [
      {
        path: 'delete',
        name: 'competition-admin-delete',
        component: () => import('../views/competition/DeleteComnpetitionPage.vue'),
      },
      {
        path: 'nuevo-torneo',
        name: 'competition-admin-new-torneo',
        component: () => import('../views/competition/NewTorneoCompeAdminPage.vue'),
      },
      {
        path: 'deportistas-admin',
        component: () => import('../views/competition/DeportistasCompeAdminPage.vue'),
        children: [
          {
            path: '',
            name: 'competition-admin-deportistas',
            component: () => import('../views/competition/DeportistasListPage.vue'),
          },
          {
            path: 'tools',
            name: 'competition-admin-deportistas-tools',
            component: () => import('../views/competition/DeportistasToolsListPage.vue'),
          },
          {
            path: 'generar-url-player',
            name: 'compe-admin-depor-generar-url',
            component: () => import('../views/competition/DeportistaGenerarUrlPage.vue'),
          },
          {
            path: 'add-url-player',
            name: 'compe-admin-depor-add-url',
            component: () => import('../views/competition/DeportistaAddUrlPage.vue'),
          },
          {
            path: 'update-url-player/:idUrl',
            name: 'compe-admin-depor-update-url',
            component: () => import('../views/competition/DeportistaEditUrlPage.vue'),
          },
          // ========================= url para componentes en venta para Competicion Admin ===========================================
          {
            path: 'componente-compe/:idDepor/ficha-jugador',
            name: 'componente-compe-ficha',
            component: () => import('../viewshop/competicion/FichaPlayerCompeAdminPage.vue'),
          },
          // ========================= FIN url para componentes en venta para Competicion Admin ===========================================
        ]
      },
    ]
  },
  {
    path: 'competition/admin/:usernameCompetition',
    component: () => import('../views/competition/CompetitionAdminPage.vue'),
    meta: {requiresAuth: true, tipoRuta: 'C'},
    children: [
      {
        path: '',
        name: 'competition-admin-torneos',
        component: () => import('../views/competition/TorneoByCompetitionAdminPage.vue'),
      },
    ]
  },
]

export default competitionUserRutes
